import { Place } from '../../types';
import { TemplateComponent } from '../DocumentGenerator';

export type AddressTemplateType = {
  description?: string;
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  addressCountry?: string;
  hasLineTwo?: boolean;
  phone?: string;
};

export const AddressComponent: TemplateComponent<Place, AddressTemplateType, void, true> = {
  templatize: (address) => {
    if (!address) {
      return {};
    }

    const { description, streetAddress1, streetAddress2, city, state, postalCode, addressCountry } = address;

    const appendCommaToCity = state || postalCode;

    const formattedCity = appendCommaToCity && city ? `${city},` : city;

    const hasLineTwo = !!(city || state || postalCode);

    return {
      description,
      streetAddress1,
      streetAddress2,
      city: formattedCity,
      state,
      postalCode,
      addressCountry,
      hasLineTwo,
      flat: [description, streetAddress1, streetAddress2, formattedCity, state, postalCode, addressCountry]
        .filter(Boolean)
        .join(' '),
      phone: address?.phone,
    };
  },
  definitionMap: {
    description: { label: 'Description', type: 'string' },
    streetAddress1: { label: 'Street Address 1', type: 'string' },
    streetAddress2: { label: 'Street Address 2', type: 'string' },
    city: { label: 'City', type: 'string' },
    state: { label: 'State', type: 'string' },
    postalCode: { label: 'Postal Code', type: 'string' },
    addressCountry: { label: 'Country', type: 'string' },
    hasLineTwo: { label: 'Has Line Two', type: 'boolean' },
    phone: { label: 'Phone', type: 'string' },
  },
};
